import React from 'react';
import ReactCountryFlag from 'react-country-flag';
import Select from 'react-select';
import useDarkMode from '../../../hooks/useDarkMode';
import { useTranslation } from 'react-i18next';

const CountryFlagWithPhoneCodeSelector = ({ onSelect, tableOptionc, isError }) => {
	const { t } = useTranslation();
	const { darkModeStatus } = useDarkMode();

	const handleCountrySelect = (country) => {
		onSelect(country);
	};

	const customOptionLabel = (country) => (
		<div className='d-flex flex-row'>
			<ReactCountryFlag
				countryCode={country.code}
				svg
				style={{
					width: '1.5em',
					height: '1.5em',
				}}
			/>
			<span style={{ marginLeft: '5px' }}>{country.phoneCode}</span>
			<span style={{ marginLeft: '5px' }}>{country.name}</span>
		</div>
	);

	return (
		<div>
			<Select
				components={{ IndicatorSeparator: null }}
				placeholder={`${t('Select')}...`}
				onChange={(e) => handleCountrySelect(e)}
				formatOptionLabel={customOptionLabel}
				getOptionValue={(option) => option.phoneCode}
				styles={{
					singleValue: (provided) => ({
						...provided,
						color: darkModeStatus ? 'white' : '#323232',
					}),
					control: (base, state) => ({
						...base,
						background: darkModeStatus ? '#212529' : '#f8f9fa',
						borderRadius: '1rem',
						border: isError
							? '2px solid red'
							: state.isFocused
							? darkModeStatus
								? '3px solid #36345a'
								: '3px solid #dad6f4'
							: '3px solid transparent',
						boxShadow: 'inset 0 1px 2px rgba(0, 0, 0, 0.075)',
						'&:hover': {
							borderColor: isError
								? 'red'
								: state.isFocused
								? darkModeStatus
									? '#36345a'
									: '#dad6f4'
								: 'transparent',
						},
					}),

					dropdownIndicator: (styles, state) => ({
						...styles,
						paddingBottom: 2,
						paddingTop: 2,
						color: darkModeStatus ? '#323232' : '#6c757d',
						'&:hover': {
							color: darkModeStatus ? '#323232' : '#6c757d',
						},
					}),

					menu: (base) => ({
						...base,
						borderRadius: '1rem',
						border: '1px solid #5c5d5f',
						background: darkModeStatus && '#212529',
					}),
					option: (provided, state) => ({
						...provided,
						backgroundColor: 'transparent',
						color: state.isSelected && !darkModeStatus && 'black',
						'&:hover': {
							backgroundColor: 'rgb(38, 132, 255)',
						},
					}),
					placeholder: (base) => ({
						...base,
						color: darkModeStatus ? 'white' : '#323232',
						fontWeight: '600',
					}),
					input: (base) => ({
						...base,
						color: darkModeStatus ? 'white' : '#323232',
						fontWeight: '600',
					}),
				}}
				options={tableOptionc}
			/>
		</div>
	);
};

export default CountryFlagWithPhoneCodeSelector;

{
	/* 
import React, { useState } from 'react';
import ReactCountryFlag from 'react-country-flag';
import Select from '../../../components/bootstrap/forms/Select';

const CountryFlagWithPhoneCodeSelector = ({ onSelect, tableOptionc, isError }) => {
	const [selectedCountry, setSelectedCountry] = useState(null);

  const countries = [
    { code: 'US', name: 'United States', phoneCode: '+1' },
    // Add more countries as needed
  ];

//   useEffect(() => {
// 		if (value?.phoneCode) setSelectedCountry(value)
//         else setSelectedCountry(null)
// 	}, [value?.phoneCode]);

  const handleCountrySelect = (country) => {
    setSelectedCountry(country);
    onSelect(country);
  };

  return (
    <div>
      <Select
				// value={JSON.stringify(value)}
				style={{border: isError ? '2px solid red': '2px solid transparent',}}
				onChange={(e) => handleCountrySelect(JSON.parse(e.target.value))}>
				<option value={null} disabled selected hidden>Select a Phone Code</option>
				{tableOptionc?.map((country, index) => (
					<option key={index} value={JSON.stringify(country)}>
						{/* <ReactCountryFlag countryCode={country.code} svg style={{ marginRight: '0.5em' }} /> *;/}
						{`(${country.phoneCode})` /*`${country.name} (${country.phoneCode})`*;/}
						
					</option>
				))}
			</Select>
			{selectedCountry && (
				<ReactCountryFlag
					countryCode={selectedCountry.code}
					style={{
						width: '2em',
						height: '2em',
						paddingRight : '2px'
					}}
					svg
					className='selected-flag'
				/>
			)}
    </div>
  );
};

export default CountryFlagWithPhoneCodeSelector;

*/
}
